import {AfterViewInit, Component, OnInit} from '@angular/core';
import {RestService} from '../../shared/service/rest.service';
import {UserProfileEntity} from 'src/shared/model/UserProfile';
import * as CryptoJS from 'crypto-js';
import {LoginProvider} from 'src/shared/service/login.service';
import {AuthService} from 'src/shared/service/auth.service';
import {Router} from '@angular/router';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {DictionaryPipe} from '../../shared/pipes/dictionary.pipe';
import {getErrorMessageText} from '../helper';
import {finalize} from 'rxjs/operators'; // Import NgxUiLoaderService
import {DynamicModalService} from '../ui-components/dynamic-modals/dynamic-modal.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  providers: [DictionaryPipe]
})
export class LoginPageComponent implements OnInit, AfterViewInit {
  userProfile: UserProfileEntity = new UserProfileEntity();
  key = CryptoJS.enc.Utf8.parse('7061737323313233');
  iv = CryptoJS.enc.Utf8.parse('7061737323313233');
  encrypted = null;
  decrypted = null;
  display = false;
  alertMessage: string;
  bgImageUrl: string;
  footerImage: string;
  products: any = [];
  showPassword: boolean;
  buildVersion: string;
  applicationVersion: string = '';
  clientDatabaseErrorMessage: string;
  showProxyLink: boolean;
  login2faUrl = 'login2fa';


  constructor(public rest: RestService,
              private loginProvider: LoginProvider,
              public authService: AuthService,
              private router: Router,
              private ngxService: NgxUiLoaderService,
              private dictionaryPipe: DictionaryPipe,
              private dynamicModalService: DynamicModalService) {
  }

  ngOnInit() {
    this.authService.configurationSet$.subscribe(() => {
      this.update();
      this.checkClientDatabaseStatus();
    });
    this.update();

  }

  getApplicationVersion() {
    let rawFile = new XMLHttpRequest();
    rawFile.open('GET', 'assets/svn_rev.txt', false);
    rawFile.onreadystatechange = () => {
      if (rawFile.readyState === 4) {
        if (rawFile.status === 200 || rawFile.status == 0) {
          let responseText: string = rawFile.responseText;
          responseText = responseText.replace(new RegExp('\"', 'g'), '');
          this.applicationVersion = '/AP ' + responseText;
        }
      }
    };
    rawFile.send(null);
  }

  tryToNavigate(url: string): void {
    if (this.clientDatabaseErrorMessage) {
      this.display = true;
      this.alertMessage = this.clientDatabaseErrorMessage;
    } else {
      this.router.navigate([url]);
    }
  }

  private checkClientDatabaseStatus(): void {
    this.ngxService.start();
    this.loginProvider.checkClientDatabaseStatus().pipe(finalize(() => this.ngxService.stop())).subscribe(
      () => {
      },
      error => {
        this.clientDatabaseErrorMessage = error.error && error.error.Message;
        this.display = true;
        this.alertMessage = this.clientDatabaseErrorMessage;
      });
  }

  handleMissingImage(event: Event) {
    (event.target as HTMLImageElement).style.display = 'none';
  }

  update() {
    this.getApplicationVersion();
    this.showProxyLink = this.authService.WpProxyFlag === 'Y';
    this.buildVersion = ' DB ' + this.authService.buildVersion + this.applicationVersion;
    this.bgImageUrl = this.authService.clientBackgroundImageUrl; // to prevent ExpressionChangedAfterItHasBeenCheckedError
    this.footerImage = this.authService.clientFooterImageUrl; // to prevent ExpressionChangedAfterItHasBeenCheckedError
  }

  ngAfterViewInit() {
    this.authService.accessTokenRemovedSubj.next(true);
  }

  login() {
    if (this.clientDatabaseErrorMessage) {
      this.display = true;
      this.alertMessage = this.clientDatabaseErrorMessage;
      return;
    }

    if (!this.userProfile.UserId) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('ENTER_USERNAME');
      return;
    }
    if (!this.userProfile.Password) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('ENTER_PASSWORD');
      return;
    }

    let UserId = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(this.userProfile.UserId), this.key,
      {
        keySize: 128 / 8,
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    let Password = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(this.userProfile.Password), this.key,
      {
        keySize: 128 / 8,
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

    UserId = UserId.toString();
    Password = Password.toString();

    const loginData = {
      grant_type: 'password',
      username: UserId,
      password: Password
    };
    this.ngxService.start();
    this.authService.resetAllLocalStorageData();
    this.loginProvider.loginToken(loginData, this.authService.get2faRememberToken(UserId))
      .pipe(finalize(() => this.ngxService.stop()))
      .subscribe(
        posts => {
          this.authService.AccessToken = posts.access_token;
          this.authService.storedFilters = null;
          this.getConfigurationDataOfLoggedInUser();
        },
        error => {
          if (error?.error?.error === '2_FA_CODE_SENT') {
            (document.getElementById('password') as any).value = '';
            this.dynamicModalService.modal(this.login2faUrl, {email: error?.error.error_description, loginData: loginData}, '700px', 'auto')
              .subscribe((posts: { access_token: string, two_fa_remember_token: string }) => {
                if (posts?.access_token) {
                  this.authService.AccessToken = posts.access_token;
                  this.authService.set2faRememberToken(UserId, posts.two_fa_remember_token ?? '');
                  this.authService.storedFilters = null;
                  this.getConfigurationDataOfLoggedInUser();
                }
              });
          } else {
            this.display = true;
            this.alertMessage = getErrorMessageText(error);
          }
        });
  }

  getConfigurationDataOfLoggedInUser() {
    this.authService.setAuthentication(this.userProfile.UserId);

    this.loginProvider.getData('api/Configuration/GetLoggedInUserConfigurationData').subscribe(
      (posts) => {
        this.authService.UserType = posts.UserType;
        this.authService.UserName = posts.UserName;
        this.authService.UserClass = posts.UserClass;
        this.authService.RecordNum = posts.RecordNum;
        this.authService.WpUserNum = posts.WpUserNum;
        this.authService.accessTokenRemovedSubj.next(false);
        // Check if Security question fields are blank,  then navigate to set security question
        if (posts.SetUpSecurityQuestion) {
          this.authService.navigateToUrl('set-security-question', {
            returnUrl: 'home',
            userNumber: this.userProfile.UserId
          });
        } else {

          this.authService.navigateToUrl('home');
        }
      },
      (error) => {
        this.display = true;
        this.alertMessage = this.dictionaryPipe.transform('DEFAULT_ERROR'); // TODO: replace with error message from BE
      }
    );
  }

  onConfirm(next: boolean) {
    this.display = false;
  }

}
